




import Vue from 'vue';
import SelectDropdown from './dropdowns/SelectDropdown/SelectDropdown.vue';

export default Vue.extend({
  name: 'ServiceSelector',
  props: {
  },
  components: {
    SelectDropdown,
  },
});
